<template>
  <div class="layerWrapper active" style="display: block;" tabindex="0">
    <div class="cbox layerBox popWidM" ref="layerBox"
      :style="{'display': 'block', 'opacity': '1', ...style}">
      <div class="cart-popup__dialog">
        <div class="cart-popup__content payment">
          <div class="cart-popup__item-info amway-theme" style="padding:0;">
            <div>
              <img src="@/views/surveys/sapporo/images/activity/activity_infomation.jpg" alt="액티비티 안내" style="width:100%">
            </div>
          </div>
        </div>
        <div
          class="cart-popup__item-link" style="border:none;">
          <a @click="closePopup" class="bt-akl-blue btn_close NCAcmi_cont03_popup">확인</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { SURVEY_SAPPORO, TOGGLE_ACTIVITY_POPUP } from '@/store/actions/survey'
import { PopupMixin } from '../mixins'

export default {
  name: 'SurveyPopupLayerActivity',
  mixins: [PopupMixin],
  computed: {
    ...mapState(SURVEY_SAPPORO, {
      pinLevel: state => state.pin_level,
      show: state => state.popup_activity,
    }),
    ...mapGetters(SURVEY_SAPPORO, {
    }),
  },
  watch: {
    show(isOpen) {
      if(isOpen) {
        this.htmlEl.classList.add("scrollLock");
        this.uiLayerMask.classList.add("on");
        this.uiLayerMask.style.display = 'block';
        window.addEventListener('resize', this.layerTypeBasic);
        this.layerTypeBasic();
      } else {
        this.htmlEl.classList.remove("scrollLock");
        this.uiLayerMask.classList.remove("on");
        this.uiLayerMask.style.display = 'none';
        window.removeEventListener('resize', this.layerTypeBasic);
      }
    }
  },
  methods: {
    closePopup() {
      this.$store.commit(`${SURVEY_SAPPORO}/${TOGGLE_ACTIVITY_POPUP}`, false);
    }
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/surveys/sapporo/components/SurveyPopupLayerActivity.vue